import { Page } from "../../shared/utils/http-utils";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  Notification,
  NotificationCounter,
  UpdateNotificationSettingsRequest,
  UserNotificationListItem,
} from "../models/Notification";

export const NotificationApi = {
  list: async (pageSize: number = 5, pageNumber: number = 0) => {
    return await jwtAuthAxios().get<Page<Notification>>(`/notifications`, {
      params: { "page[size]": pageSize, "page[number]": pageNumber },
    });
  },

  getCounter: async () => {
    return await jwtAuthAxios().get<NotificationCounter>(
      `/notifications/counter`
    );
  },

  readAll: async () => {
    return await jwtAuthAxios().post<undefined>(`/notifications/read-all`);
  },

  read: async (notificationId: number) => {
    return await jwtAuthAxios().put<Notification>(
      `/notifications/${notificationId}/read`
    );
  },

  unread: async (notificationId: number) => {
    return await jwtAuthAxios().put<Notification>(
      `/notifications/${notificationId}/unread`
    );
  },

  delete: async (notificationId: number) => {
    return await jwtAuthAxios().delete<undefined>(
      `/notifications/${notificationId}`
    );
  },

  updateSettings: async (updateSettings: UpdateNotificationSettingsRequest) => {
    return await jwtAuthAxios().put<UserNotificationListItem[]>(
      `/notifications/settings`,
      updateSettings
    );
  },

  getUserNotificationListItem: async () => {
    return await jwtAuthAxios().get<UserNotificationListItem[]>(
      `/notifications/settings`
    );
  },
};
